<p-button
  [label]="label"
  [disabled]="disabled"
  [ngClass]="getButtonClasses()"
  class="custom-button"
  (click)="handleClick($event)">
  <span *ngIf="imageSrc" class="button-image">
    <img [src]="imageSrc" alt="button image" />
  </span>
  <ng-container *ngIf="icon">
    <lucide-icon [name]="icon" class="custom-icon"></lucide-icon>
  </ng-container>
</p-button>